// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 380px) {
  .mob-input {
    padding-top: 50px !important;
  }
}
/* Target MUI ListItemText and common chat message containers */
.toScroll,
.chat-scroll-container,
.chat-message,
.message-text,
.MuiListItemText-root,
.MuiListItemText-root .MuiTypography-root {
  white-space: pre-wrap;
  /* preserve newlines and wrap */
  overflow-wrap: break-word;
  /* preferred: break at normal break points */
  overflow-wrap: anywhere;
  /* allow extra flexibility for long tokens */
  word-break: normal;
  /* DO NOT use break-all (it breaks between letters) */
}

/* Ensure links/images don't force weird wrapping */
.toScroll img,
.toScroll video,
.toScroll a {
  max-width: 100%;
  height: auto;
  word-break: normal;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/common/cards/chat-card/chat-feed.scss"],"names":[],"mappings":"AAAA;EACI;IACI,4BAAA;EACN;AACF;AAGA,+DAAA;AACA;;;;;;EAMI,qBAAA;EACA,+BAAA;EACA,yBAAA;EACA,4CAAA;EACA,uBAAA;EACA,4CAAA;EACA,kBAAA;EACA,qDAAA;AADJ;;AAIA,mDAAA;AACA;;;EAGI,eAAA;EACA,YAAA;EACA,kBAAA;AADJ","sourcesContent":["@media only screen and (max-width: 380px) {\n    .mob-input {\n        padding-top: 50px !important;\n    }\n}\n\n// Prevent awkward single-letter breaks in chat messages\n/* Target MUI ListItemText and common chat message containers */\n.toScroll,\n.chat-scroll-container,\n.chat-message,\n.message-text,\n.MuiListItemText-root,\n.MuiListItemText-root .MuiTypography-root {\n    white-space: pre-wrap;\n    /* preserve newlines and wrap */\n    overflow-wrap: break-word;\n    /* preferred: break at normal break points */\n    overflow-wrap: anywhere;\n    /* allow extra flexibility for long tokens */\n    word-break: normal;\n    /* DO NOT use break-all (it breaks between letters) */\n}\n\n/* Ensure links/images don't force weird wrapping */\n.toScroll img,\n.toScroll video,\n.toScroll a {\n    max-width: 100%;\n    height: auto;\n    word-break: normal;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
